export enum ESiteType {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}
